import { updateStateBlobAndVariants } from "./etV2.js";
export const checkForNewClientsidePayload = (newClientsidePayload) => {
    if (newClientsidePayload) {
        if (newClientsidePayload !== window?.__GLOBAL_CONTEXT__?.clientsidePayload) {
            try {
                updateStateBlobAndVariants(newClientsidePayload);
                window.__GLOBAL_CONTEXT__.clientsidePayload = newClientsidePayload;
            }
            catch (error) {
                throw new Error("EtV2 threw an error while updating stateBlob and variants");
            }
        }
    }
};
export const updateClientSideContext = (soylentExperiments) => {
    if (soylentExperiments) {
        try {
            window.__GLOBAL_CONTEXT__.experiments = {
                ...window.__GLOBAL_CONTEXT__.experiments,
                ...JSON.parse(soylentExperiments)
            };
        }
        catch {
            throw new Error("Error parsing soylent experiments payload");
        }
    }
};
